/* app-sites.js — native apps as GhostStat sites in the web app (App tracking, step 17b).
 *
 * An app is a site with site_type 'app' (api/lib/AppTracking.php). This file makes the web app follow it:
 *   - body.gs-site-app while the current site is an app: [data-web-only] hides, [data-app-only] shows
 *     (the install page swaps the <script> snippet for the SDK steps, Site settings hides Tracking);
 *   - labels that mean something else for an app: Referrers → Install sources, Pages → Screens,
 *     Browsers → App versions (screens are stored as pages; "browser" is "App" + the app version);
 *   - New site: a Website / App choice (platform + bundle IDs, "Create app");
 *   - Site settings → App & links: the allow-list, and the website <-> app link;
 *   - a Web | App switch in the top bar when the current site is linked, and a phone mark on app sites
 *     in the site menu.
 * Loaded before interactions.js, so its gs:ready listener runs first and the labels are right before
 * any page draws. No cookies, no storage of its own. Strings: EN + NL here (same keys as partials/app-strings.php).
 */
(function () {
  'use strict';

  var L = {
    en: {
      screens: 'Screens', install_sources: 'Install sources', app_versions: 'App versions', shown_as: 'Shown as',
      web: 'Website', app: 'App', link_none: 'Not linked',
      switch_tip: 'Linked website and app. Visitors cannot be matched between the two, so combined numbers are a sum.',
      err_bad_bundle_id: 'A bundle ID must look like com.example.app — letters, digits, dots, hyphens.',
      err_bundle_ids_required: 'Add at least one bundle ID or package name.',
      err_too_many_bundle_ids: 'At most 20 bundle IDs.',
      err_bad_app_platform: 'Choose a platform.',
      err_name_required: 'Give the app a name.',
      err_site_limit_reached: 'Site limit reached for your plan.',
      err_link_web_to_app: 'A website can only be linked to an app, and an app to a website.',
      err_linked_site_not_found: 'That site is not one of yours.',
      err_generic: 'Could not save. Try again.',
      created: 'App created. Next: add the SDK to your app.',
      checking: 'Checking…', verified: '✓ Receiving data — %n% screens', none_yet: 'No data yet — run the app with the SDK added',
      web_only_title: '%p% is for websites',
      web_only_text: 'It measures what only a web page has — the page itself, how it is read or clicked, how fast it loads, or where on the web visitors came from. Your app\u2019s screens, events, visitors and live presence are on the dashboard and in the plugins listed for this app.',
      web_only_dash: 'Go to the dashboard', web_only_switch: 'Open it for %s%',
    },
    nl: {
      screens: 'Schermen', install_sources: 'Installatiebronnen', app_versions: 'App-versies', shown_as: 'Weergegeven als',
      web: 'Website', app: 'App', link_none: 'Niet gekoppeld',
      switch_tip: 'Gekoppelde website en app. Bezoekers kunnen niet tussen beide worden gematcht, dus opgetelde aantallen zijn een som.',
      err_bad_bundle_id: 'Een bundle-ID ziet eruit als com.voorbeeld.app — letters, cijfers, punten, streepjes.',
      err_bundle_ids_required: 'Voeg minstens één bundle-ID of pakketnaam toe.',
      err_too_many_bundle_ids: 'Maximaal 20 bundle-ID\'s.',
      err_bad_app_platform: 'Kies een platform.',
      err_name_required: 'Geef de app een naam.',
      err_site_limit_reached: 'Sitelimiet van je abonnement bereikt.',
      err_link_web_to_app: 'Een website kan alleen aan een app worden gekoppeld, en een app aan een website.',
      err_linked_site_not_found: 'Die site is niet van jou.',
      err_generic: 'Opslaan lukte niet. Probeer het opnieuw.',
      created: 'App aangemaakt. Volgende stap: voeg de SDK toe aan je app.',
      checking: 'Controleren…', verified: '✓ Gegevens komen binnen — %n% schermen', none_yet: 'Nog geen gegevens — start de app met de SDK',
      web_only_title: '%p% is voor websites',
      web_only_text: 'Het meet wat alleen een webpagina heeft — de pagina zelf, hoe die gelezen of aangeklikt wordt, hoe snel die laadt, of waar op het web bezoekers vandaan kwamen. De schermen, events, bezoekers en live aanwezigheid van je app staan op het dashboard en in de plugins die voor deze app getoond worden.',
      web_only_dash: 'Naar het dashboard', web_only_switch: 'Openen voor %s%',
    }
  };
  function S(k, v) {
    var lang = (window.GS && GS.locale === 'nl') ? 'nl' : 'en';
    var s = (L[lang][k] != null ? L[lang][k] : L.en[k]) || k;
    if (v) for (var x in v) s = s.split('%' + x + '%').join(v[x]);
    return s;
  }
  function gs(k) { return document.querySelector('[data-gs="' + k + '"]'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function isApp(site) { return !!site && site.site_type === 'app'; }
  function current() { return (window.GS && GS.sites || []).find(function (x) { return x.public_key === GS.site; }) || null; }
  function byId(id) { return (GS.sites || []).find(function (x) { return +x.id === +id; }) || null; }
  var BUNDLE_RE = /^[A-Za-z0-9_-]+(\.[A-Za-z0-9_-]+)+$/;
  function bundleList(text) { return String(text || '').split(/[\s,]+/).map(function (x) { return x.trim(); }).filter(Boolean); }
  function bundleError(list) {
    if (!list.length) return 'bundle_ids_required';
    if (list.length > 20) return 'too_many_bundle_ids';
    for (var i = 0; i < list.length; i++) if (list[i].length > 155 || !BUNDLE_RE.test(list[i])) return 'bad_bundle_id';
    return null;
  }
  function errText(code) { var k = 'err_' + (code || 'generic'); var t = S(k); return t === k ? S('err_generic') : t; }

  /* ---- visibility + styles, from the first moment (before gs:ready the site is not known: web) ---- */
  (function style() {
    var css = 'body:not(.gs-site-app) [data-app-only]{display:none!important}'
      + 'body.gs-site-app [data-web-only]{display:none!important}'
      + '.gs-app-step{font-size:14px;font-weight:700;margin:18px 0 8px}'
      + '.gs-app-code{background:var(--bg-2,#f6f7f9);border:1px solid var(--line-2,#e3e6ea);border-radius:var(--r-sm,4px);padding:10px 12px;font-size:12.5px;white-space:pre-wrap;word-break:break-word;margin-bottom:12px}'
      + '.gs-app-bundles{list-style:none;padding:0;margin:0;font-family:ui-monospace,Menlo,monospace;font-size:12.5px;word-break:break-all}'
      + '.gs-app-bundles li{padding:3px 0}'
      + '.gs-sdk-tabs .btn{min-width:120px}'
      + '.gs-kind-switch{margin-right:8px;align-self:center}'
      + '.gs-kind-switch button{display:inline-flex;align-items:center;gap:5px}'
      + '.gs-site-kind{margin-left:6px;opacity:.6;font-size:12px}'
      + '@media(max-width:575.98px){.gs-kind-switch{display:none!important}}';
    var el = document.createElement('style'); el.setAttribute('data-app-sites', ''); el.textContent = css;
    (document.head || document.documentElement).appendChild(el);
  })();

  /* ---- labels that change meaning for an app ---- */
  function relabel(app) {
    function swap(el, text) {
      if (!el) return;
      if (el.dataset.webLabel == null) el.dataset.webLabel = el.textContent;
      el.textContent = app ? text : el.dataset.webLabel;
    }
    swap(document.querySelector('.gs-nav-link[href="/referrers"] span'), S('install_sources'));
    // Report pages: /content (pages), /referrers, /browsers, or /report?m=…
    var m = (location.search.match(/[?&]m=([a-z]+)/) || [])[1];
    var p = location.pathname.replace(/\/+$/, '');
    var kind = m || { '/content': 'pages', '/referrers': 'referrers', '/browsers': 'browsers' }[p];
    var h1 = document.querySelector('.gs-content h1, main h1');
    if (kind === 'pages') swap(h1, S('screens'));
    else if (kind === 'referrers') swap(h1, S('install_sources'));
    else if (kind === 'browsers') swap(h1, S('app_versions'));
    // Site settings → General: the domain field holds the first bundle ID for an app.
    var dom = gs('ss-domain'); if (dom) { var lab = dom.closest('.mb-3'); swap(lab && lab.querySelector('label'), S('shown_as')); }
  }

  /* ---- top bar: Web | App switch for a linked pair; a phone mark on app sites in the site menu ---- */
  function topbar(site) {
    document.querySelectorAll('[data-gs="site-list"] [data-key]').forEach(function (a) {
      var s = (GS.sites || []).find(function (x) { return x.public_key === a.dataset.key; });
      if (isApp(s) && !a.querySelector('.gs-site-kind')) {
        var nm = a.querySelector('.gs-site-nm') || a;
        nm.insertAdjacentHTML('beforeend', '<i class="bi bi-phone gs-site-kind" aria-label="' + esc(S('app')) + '"></i>');
      }
    });
    var old = document.querySelector('.gs-kind-switch'); if (old) old.remove();
    var other = site && site.linked_site_id ? byId(site.linked_site_id) : null;
    var host = document.querySelector('[data-gs="kind-switch-host"]') || document.querySelector('.topbar .top-right');   // the Ghost shell's top bar, else the old one
    if (!other || !host) return;
    var web = isApp(site) ? other : site, app = isApp(site) ? site : other;
    var seg = document.createElement('div');
    seg.className = 'gs-seg gs-kind-switch'; seg.setAttribute('role', 'tablist'); seg.title = S('switch_tip');
    seg.innerHTML = [[web, 'bi-globe2', S('web')], [app, 'bi-phone', S('app')]].map(function (x) {
      var on = x[0].public_key === site.public_key;
      return '<button type="button" role="tab" aria-selected="' + on + '" class="' + (on ? 'on' : '') + '" data-key="' + esc(x[0].public_key) + '">'
        + '<i class="bi ' + x[1] + '"></i>' + esc(x[2]) + '</button>';
    }).join('');
    seg.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-key]'); if (!b || b.dataset.key === GS.site) return;
      try { localStorage.setItem('gs_site', b.dataset.key); } catch (_) {}   // the same key main.js remembers the site in
      var u = new URL(location.href); u.searchParams.set('s', b.dataset.key);
      location.assign(u.pathname + u.search + u.hash);
    });
    host.insertBefore(seg, host.firstChild);
  }

  /* ---- install page: the SDK card ---- */
  function install(site) {
    var key = gs('app-site-key'); if (!key || !site) return;
    key.value = site.public_key;
    ['app-init', 'app-init-android'].forEach(function (id) {       // Swift "siteKey: …", Kotlin "siteKey = …"
      var init = gs(id); if (init) init.textContent = init.textContent.replace(/siteKey(: | = )"[^"]*"/, 'siteKey$1"' + site.public_key + '"');
    });
    sdkTab(site.app_platform === 'android' ? 'android' : 'ios');
    var ul = gs('app-bundle-list');
    if (ul) ul.innerHTML = (site.app_bundle_ids || []).map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('');
    if (isApp(site)) verify(false);
  }
  /* iOS | Android steps on the install page: the site's platform picks the first one shown. */
  function sdkTab(which) {
    document.querySelectorAll('[data-sdk-tab]').forEach(function (b) {
      var on = b.getAttribute('data-sdk-tab') === which;
      b.classList.toggle('active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-sdk-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-sdk-pane') !== which; });
  }
  function verify(pending) {
    var st = gs('app-verify-status'); if (!st || !GS.site) return;
    if (pending) { st.className = 'gs-badge gray'; st.textContent = S('checking'); }
    var to = new Date(), from = new Date(); from.setFullYear(to.getFullYear() - 2);
    var f = function (d) { return d.toISOString().slice(0, 10); };
    GS.api('/stats/overview?site=' + encodeURIComponent(GS.site) + '&from=' + f(from) + '&to=' + f(to)).then(function (r) {
      var pv = (r && r.ok && r.data) ? (+r.data.pageviews || 0) : 0;
      if (pv > 0) { st.className = 'gs-badge'; st.textContent = S('verified', { n: pv.toLocaleString() }); }
      else if (pending) { st.className = 'gs-badge warn'; st.textContent = S('none_yet'); }
    }).catch(function () {});
  }

  /* ---- Site settings → App & links ---- */
  function settings(site) {
    var sel = gs('ss-link'); if (!sel || !site) return;
    var pf = gs('ss-app-platform'), ta = gs('ss-app-bundles');
    if (isApp(site)) {
      if (pf) pf.value = site.app_platform || 'ios';
      if (ta) ta.value = (site.app_bundle_ids || []).join('\n');
    }
    var others = (GS.sites || []).filter(function (x) { return x.id !== site.id && isApp(x) !== isApp(site); });
    sel.innerHTML = '<option value="">' + esc(S('link_none')) + '</option>' + others.map(function (x) {
      return '<option value="' + x.id + '">' + esc(x.name) + ' — ' + esc(x.domain) + '</option>';
    }).join('');
    sel.value = site.linked_site_id ? String(site.linked_site_id) : '';
    // A hidden panel (Tracking, for an app) must not stay the open one.
    var on = document.querySelector('.gs-settings-nav a[data-sec].on');
    if (on && getComputedStyle(on).display === 'none') { var g = document.querySelector('.gs-settings-nav a[data-sec="general"]'); if (g) g.click(); }
  }
  async function saveSettings() {
    var site = current(); if (!site) return;
    var err = gs('ss-app-err'), ok = gs('ss-app-ok');
    err.classList.add('d-none'); ok.classList.add('d-none');
    // /sites/update always writes name, domain, public stats, subdomains, stitching and category: send what
    // the site has, so saving this section changes nothing else.
    var body = { id: site.id, name: site.name, domain: site.domain, public_stats: !!+site.public_stats,
      track_subdomains: !!+site.track_subdomains, stitch_visitors: !!+site.stitch_visitors,
      category_id: site.category_id == null ? '' : site.category_id };
    var link = gs('ss-link').value;
    body.linked_site_id = link ? +link : null;
    if (isApp(site)) {
      var list = bundleList(gs('ss-app-bundles').value), be = bundleError(list);
      if (be) { err.textContent = errText(be); err.classList.remove('d-none'); return; }
      body.app_platform = gs('ss-app-platform').value;
      body.app_bundle_ids = list;
    }
    var r = await GS.api('/sites/update', { method: 'POST', body: JSON.stringify(body) });
    if (!r || !r.ok) { err.textContent = errText(r && r.data && r.data.error); err.classList.remove('d-none'); return; }
    // Mirror the link on both sides locally (the server released any earlier partner too).
    (GS.sites || []).forEach(function (x) {
      if (+x.linked_site_id === +site.id || (site.linked_site_id && +x.id === +site.linked_site_id)) x.linked_site_id = null;
    });
    site.linked_site_id = body.linked_site_id;
    var partner = body.linked_site_id ? byId(body.linked_site_id) : null;
    if (partner) { if (partner.linked_site_id) { var p2 = byId(partner.linked_site_id); if (p2) p2.linked_site_id = null; } partner.linked_site_id = site.id; }
    if (isApp(site)) { site.app_platform = body.app_platform; site.app_bundle_ids = body.app_bundle_ids; }
    ok.classList.remove('d-none'); setTimeout(function () { ok.classList.add('d-none'); }, 2500);
    apply();
  }

  /* ---- New site: Website / App ---- */
  function newSite() {
    var seg = gs('new-kind'); if (!seg) return;
    var fields = gs('new-app-fields'), dom = gs('new-domain'), domWrap = dom && dom.closest('.mb-3');
    var cSite = gs('create-site'), cApp = gs('create-app');
    function mode(kind) {
      seg.querySelectorAll('button[data-kind]').forEach(function (b) {
        var on = b.dataset.kind === kind; b.classList.toggle('on', on); b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      var app = kind === 'app';
      if (fields) fields.hidden = !app;
      if (domWrap) domWrap.hidden = app;
      if (cSite) cSite.hidden = app;
      if (cApp) cApp.hidden = !app;
      var er = gs('site-error'); if (er) er.classList.add('d-none');
    }
    seg.addEventListener('click', function (e) { var b = e.target.closest('button[data-kind]'); if (b) mode(b.dataset.kind); });
    var modal = document.getElementById('newSite');
    if (modal) modal.addEventListener('show.bs.modal', function () { mode('web'); });
    if (cApp) cApp.addEventListener('click', async function () {
      var er = gs('site-error'); er.classList.add('d-none');
      var name = (gs('new-name').value || '').trim(), list = bundleList(gs('new-app-bundles').value);
      var bad = !name ? 'name_required' : bundleError(list);
      if (bad) { er.textContent = errText(bad); er.classList.remove('d-none'); return; }
      cApp.disabled = true;
      var r = await GS.api('/sites', { method: 'POST', body: JSON.stringify({
        site_type: 'app', name: name, app_platform: gs('new-app-platform').value, app_bundle_ids: list,
        category_id: (gs('new-category') || {}).value || '' }) });
      cApp.disabled = false;
      if (!r || !r.ok || !r.data || !r.data.site) { er.textContent = errText(r && r.data && r.data.error); er.classList.remove('d-none'); return; }
      // Straight to the SDK steps for the new app.
      try { localStorage.setItem('gs_site', r.data.site.public_key); } catch (_) {}
      if (window.GSUI && GSUI.toast) GSUI.toast(S('created'));
      location.assign('/install?s=' + encodeURIComponent(r.data.site.public_key));
    });
  }

  /* ---- All sites: an app row shows its name and a phone, not its bundle ID as if it were a web address ---- */
  function siteRows() {
    var tb = gs('aw-rows'); if (!tb || tb._gsApp) return;
    tb._gsApp = true;
    function fix() {
      tb.querySelectorAll('a[data-key]:not([data-app-done])').forEach(function (a) {
        a.setAttribute('data-app-done', '');
        var s = (GS.sites || []).find(function (x) { return x.public_key === a.dataset.key; });
        if (!isApp(s)) return;
        a.innerHTML = '<i class="bi bi-phone"></i>' + esc(s.name);
        a.title = (s.app_bundle_ids || []).join(', ');
      });
    }
    new MutationObserver(fix).observe(tb, { childList: true, subtree: true });
    fix();
  }

  /* ---- a web-only plugin's page opened for an app site (App tracking, part 2): say so instead of an empty page ---- */
  function pluginFit(site) {
    var main = document.querySelector('main[data-gs-plugin]');
    if (!main || !isApp(site) || main.dataset.appChecked === site.public_key) return;
    main.dataset.appChecked = site.public_key;
    var slug = main.getAttribute('data-gs-plugin');
    GS.api('/plugins?site_id=' + encodeURIComponent(site.id)).then(function (r) {
      var not = (r && r.ok && r.data && r.data.not_for_site) || [];
      if (not.indexOf(slug) < 0 || !isApp(current())) return;
      var h = main.querySelector('h1');
      var name = h ? h.textContent.trim() : slug.replace(/-/g, ' ').replace(/^./, function (c) { return c.toUpperCase(); });
      var web = site.linked_site_id ? byId(site.linked_site_id) : null;
      var sw = web ? '<a class="btn btn-outline-secondary" href="' + location.pathname + '?s=' + encodeURIComponent(web.public_key) + '">'
        + '<i class="bi bi-globe2 me-1"></i>' + esc(S('web_only_switch', { s: web.name })) + '</a>' : '';
      main.innerHTML = '<div class="gs-card" data-gs="app-web-only" style="max-width:640px;margin:24px auto"><div class="p-4">'
        + '<div class="mb-2" style="font-size:28px;line-height:1"><i class="bi bi-globe2"></i></div>'
        + '<h2 class="mb-2">' + esc(S('web_only_title', { p: name })) + '</h2>'
        + '<p class="gs-muted mb-3">' + esc(S('web_only_text')) + '</p>'
        + '<div class="d-flex flex-wrap gap-2"><a class="btn btn-primary" href="/dashboard">' + esc(S('web_only_dash')) + '</a>' + sw + '</div>'
        + '</div></div>';
    }).catch(function () {});
  }

  function apply() {
    if (!window.GS || !GS.sites) return;
    var site = current();
    var app = isApp(site);
    document.body.classList.toggle('gs-site-app', app);
    relabel(app);
    topbar(site);
    install(site);
    settings(site);
    siteRows();
    pluginFit(site);
  }

  document.addEventListener('gs:ready', apply);
  // /site-settings#app (the install page links here): open that section once the settings menu is wired.
  document.addEventListener('gs:ready', function () {
    if (location.hash !== '#app') return;
    setTimeout(function () { var a = document.querySelector('.gs-settings-nav a[data-sec="app"]'); if (a) a.click(); }, 0);
  });
  document.addEventListener('gs:site-change', apply);
  document.addEventListener('DOMContentLoaded', function () {
    newSite();
    var sv = gs('ss-app-save'); if (sv) sv.addEventListener('click', saveSettings);
    var vf = gs('app-verify'); if (vf) vf.addEventListener('click', function () { verify(true); });
    document.querySelectorAll('[data-sdk-tab]').forEach(function (b) {
      b.addEventListener('click', function () { sdkTab(b.getAttribute('data-sdk-tab')); });
    });
    document.querySelectorAll('[data-copy-from]').forEach(function (b) {
      b.addEventListener('click', function () {
        var pre = gs(b.getAttribute('data-copy-from')); if (!pre || !navigator.clipboard) return;
        navigator.clipboard.writeText(pre.textContent); var t = b.textContent; b.textContent = '✓'; setTimeout(function () { b.textContent = t; }, 1500);
      });
    });
    var cp = gs('app-copy-init');
    if (cp) cp.addEventListener('click', function () {
      var pre = gs('app-init'); if (!pre || !navigator.clipboard) return;
      navigator.clipboard.writeText(pre.textContent); var t = cp.textContent; cp.textContent = '✓'; setTimeout(function () { cp.textContent = t; }, 1500);
    });
  });
})();
